export default "__VITE_ASSET__84eIQcbe__"